import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Common = {
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
  block?: boolean;
  large?: boolean;
};

type BtnProps = Common & ButtonHTMLAttributes<HTMLButtonElement>;

function cx(...parts: Array<string | false | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

export function PrimaryButton({
  children,
  className,
  icon,
  block,
  large,
  type = 'button',
  ...rest
}: BtnProps): JSX.Element {
  return (
    <button
      type={type}
      className={cx(
        'btn',
        'btn-primary',
        block && 'btn-block',
        large && 'btn-lg',
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}

export function SecondaryButton({
  children,
  className,
  icon,
  block,
  large,
  type = 'button',
  ...rest
}: BtnProps): JSX.Element {
  return (
    <button
      type={type}
      className={cx(
        'btn',
        'btn-secondary',
        block && 'btn-block',
        large && 'btn-lg',
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}

export function DangerButton({
  children,
  className,
  icon,
  block,
  large,
  type = 'button',
  ...rest
}: BtnProps): JSX.Element {
  return (
    <button
      type={type}
      className={cx(
        'btn',
        'btn-danger',
        block && 'btn-block',
        large && 'btn-lg',
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}

export function PrimaryLink({
  to,
  children,
  className,
  icon,
  block,
  large,
}: Common & { to: string }): JSX.Element {
  return (
    <Link
      to={to}
      className={cx(
        'btn',
        'btn-primary',
        block && 'btn-block',
        large && 'btn-lg',
        className,
      )}
    >
      {icon}
      {children}
    </Link>
  );
}

export function SecondaryLink({
  to,
  children,
  className,
  icon,
  block,
  large,
}: Common & { to: string }): JSX.Element {
  return (
    <Link
      to={to}
      className={cx(
        'btn',
        'btn-secondary',
        block && 'btn-block',
        large && 'btn-lg',
        className,
      )}
    >
      {icon}
      {children}
    </Link>
  );
}
